export default __webpack_public_path__ + "static/media/MGP_2024_Fantasy_Launch_LDB_728x100.1e126f2b.gif";